export default __webpack_public_path__ + "static/logo_black-b1a1209ae0aaa22a5f94df7433d0c425.png";